export const invoices = {
  alerts: {
    errorDuplicateEntryNumber: 'Vous avez déjà utilisé le numéro de facture « {{entryNumber}} ».',
    missingFcFiles_one: 'Le PDF de cette facture est introuvable.',
    missingFcFiles_other: 'Les PDF de ces factures sont introuvables.',
    successCreated: 'Votre facture a été créée.',
    successDeleted: 'Votre brouillon a été supprimé.',
    successResendCoInvoice: 'Votre facture a été renvoyée.',
    successUpdated: 'Votre facture a été modifiée.',
  },
  breadcrumb: {
    create: 'Détails',
    noTitle: 'Sans titre',
    overview: 'Factures',
  },
  conditionDialog: {
    title: 'Conditions générales',
  },
  createEdit: {
    advantageSimulationModal: {
      distribution: {
        commission: {
          descriptionWithCs:
            'La commission de Creative Shelter. Elle est calculée par facture, sur la base de <a href="https://my.creativeshelter.be/settings/plan">votre commission actuelle</a>, et est déduite du montant hors TVA que vous avez facturé à votre client. Nous prenons en charge toute la paperasse administrative pour que vous puissiez facturer des droits d’auteur et ainsi gagner plus au bout du compte.',
          descriptionWithCsMinimumCommissionApplied:
            'La commission de Creative Shelter. Comme le montant de votre facture est plutôt bas, la commission minimale de 12,50 € s’applique. Vous doutez d’en tirer encore un avantage net ? Contactez-nous et nous examinerons cela ensemble !',
          disclaimerWithCs: '',
          label: 'Commission Creative Shelter',
        },
        costs: {
          descriptionWithCs:
            'Nous tenons compte de frais équivalant à 20 % du montant total de la facture. Il s’agit d’une estimation : le montant réel peut être plus élevé ou plus bas, mais c’est une moyenne réaliste.',
          descriptionWithoutCs:
            'Nous tenons compte de frais équivalant à 20 % du montant total de la facture. Il s’agit d’une estimation : le montant réel peut être plus élevé ou plus bas, mais c’est une moyenne réaliste.',
          disclaimerWithCs: '',
          disclaimerWithoutCs: '',
          label: 'Frais',
        },
        netAmount: {
          descriptionWithCs:
            'Le montant net qu’il vous reste lorsque vous facturez avec Creative Shelter, après déduction de notre commission, des frais, des cotisations sociales, des impôts, … Vous le voyez vous-même, noir sur blanc : Creative Shelter, ça rapporte !',
          descriptionWithCsNoAdvantage:
            'Selon notre estimation, vous ne tirerez aucun avantage de cette facture. Si vous facturez principalement ou exclusivement des prestations non créatives, il sera plus avantageux de ne pas envoyer cette facture via nous. Vous hésitez ? N’hésitez pas à nous contacter et nous examinerons cela ensemble !',
          descriptionWithoutCs:
            'Le montant net qu’il vous reste lorsque vous facturez sans Creative Shelter, après déduction des frais, des cotisations sociales, des impôts, …\nComparez donc, Creative Shelter, ça rapporte !',
          disclaimerWithCs: '',
          disclaimerWithoutCs: '',
          label: 'Revenus nets',
        },
        socialContribution: {
          descriptionWithCs:
            'Selon la clé de répartition, votre facture est divisée en une part de droits d’auteur et une part de revenus professionnels. Sur vos revenus professionnels (après déduction des frais que vous faites valoir), vous devrez payer 20,5 % de cotisations sociales. Il s’agit des cotisations provisoires versées à votre caisse d’assurances sociales, grâce auxquelles vous constituez vos droits sociaux.',
          descriptionWithoutCs:
            'Sur le montant total de la facture, après déduction des frais que vous faites valoir, vous devrez payer 20,5 % de cotisations sociales. Il s’agit des cotisations provisoires versées à votre caisse d’assurances sociales, grâce auxquelles vous constituez vos droits sociaux.',
          disclaimerWithCs:
            'Le montant sera inférieur à celui sans Creative Shelter, puisque vous percevez une partie de vos revenus sous forme de rémunération en droits d’auteur.',
          disclaimerWithoutCs: '',
          label: 'Cotisations sociales',
        },
        taxes: {
          descriptionWithCs:
            'Selon la clé de répartition, votre facture est divisée en une part de droits d’auteur et une part de revenus professionnels. Vous ne payez l’impôt des personnes physiques que sur cette dernière part (après déduction de vos frais et de vos cotisations sociales).',
          descriptionWithoutCs:
            'Vous payez l’impôt des personnes physiques sur le montant total de la facture, après déduction de vos frais et de vos cotisations sociales. Le montant dépend de votre état civil et de vos revenus : plus vos revenus sont élevés, plus vous payez d’impôts. Et comme aucune clé de répartition ne s’applique, ce montant est plus élevé que si vous facturiez des droits d’auteur.',
          disclaimerWithCs:
            'Le taux d’imposition moyen sera plus bas, puisque vos revenus professionnels sont également réduits. Nous comptons ici avec un taux compris entre 0 % et 30 %, selon la répartition de votre facture.',
          disclaimerWithCsNotMainOccupation:
            'Vous avez indiqué exercer une activité complémentaire et nous supposons que vous percevez aussi des revenus d’une activité principale. Pour calculer la part des impôts, nous tenons compte d’un taux de 45 %.',
          disclaimerWithoutCs: '',
          label: 'Impôts',
        },
        withholdingTaxes: {
          descriptionWithCs:
            'Le précompte mobilier est un impôt calculé sur votre rémunération en droits d’auteur. Nous le calculons automatiquement pour vous, le retenons et le versons au fisc. Vous n’avez rien à faire, et vous percevez ainsi correctement une rémunération en droits d’auteur.\n\nVous voulez en savoir plus ? Lisez-le <a href="https://knowledge.creativeshelter.be/wat-is-roerende-voorheffing-en-hoe-wordt-deze-berekend" target="_blank">ici</a> !',
          disclaimerWithCs: '',
          label: 'Précompte mobilier',
        },
      },
      label: {
        withCs: 'Avec Creative Shelter',
        withoutCs: 'Sans Creative Shelter',
      },
      noDataDisclaimer: 'L’avantage ne peut pas encore être calculé. Complétez votre facture et ajoutez au moins une ligne.',
      title: 'Simulation de l’avantage',
      toggle: {
        withCs: 'Avec Creative Shelter',
        withoutCs: 'Sans Creative Shelter',
      },
      totals: {
        advantage: 'Avantage Creative Shelter',
        netAmount: 'Revenus nets',
        noAdvantage: 'Aucun avantage',
        totalInvoiced: 'Facture client',
      },
    },
    assignment: {
      description: 'Décrivez brièvement en quoi consiste votre mission.',
      fieldLabel: 'Informations sur la mission',
      title: 'Mission',
    },
    attachments: {
      attachment: 'Pièce jointe',
      description: 'Ajoutez d’éventuels documents à cette facture.',
      error: {
        delete: 'Une erreur s’est produite lors de la suppression de la pièce jointe.',
      },
      title: 'Pièces jointes',
    },
    automaticApprovalModal: {
      automatic: 'Facturation instantanée',
      description:
        'Votre facture peut être approuvée immédiatement. Vous pouvez tout de même choisir de la faire vérifier par nous, mais l’approbation prendra alors un peu plus de temps.',
      manual: 'Approuver manuellement',
      title: 'Facturation instantanée',
    },
    basicInfo: {
      description: 'Toutes les informations de base de votre facture.',
      title: 'Informations de base',
    },
    blocker: {
      leave: 'Quitter sans envoyer',
      leaveUnsaved: 'Quitter sans enregistrer',
      message:
        'Voulez-vous vraiment quitter cette page ? Votre facture reste en cours de modification jusqu’à ce que vous la renvoyiez, et d’ici là, nous ne pouvons pas l’approuver.',
      messageUnsaved:
        'Voulez-vous vraiment quitter cette page ? Vos modifications n’ont pas été enregistrées. Votre facture reste en cours de modification jusqu’à ce que vous la renvoyiez, et d’ici là, nous ne pouvons pas l’approuver.',
    },
    clientInfo: {
      addEmailReceiver: 'Ajouter un destinataire',
      emailSelfTooltip: 'Vous avez choisi de transmettre vous-même les factures et les notes de crédit à votre client.',
      peppol: 'Envoyé via Peppol',
    },
    clientModal: {
      addContact: 'Ajouter une personne de contact',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      contactsLegend: 'Choisissez une personne de contact',
      emptyList: 'Aucun client trouvé.',
      newClient: 'Nouveau client',
      searchPlaceholder: 'Rechercher un client',
      title: 'Ajouter un client',
      typeFilter: {
        all: 'Tous les types',
        organisation: 'Organisation',
        private: 'Particulier',
      },
    },
    coTooLowModal: {
      description:
        'Le montant que vous souhaitez facturer est trop bas : après notre commission, il ne vous resterait rien.\n\nModifiez votre facture en augmentant le montant, ou envoyez-la en dehors de la plateforme.',
      dismiss: 'J’ai compris !',
      title: 'Le montant de votre facture est trop bas',
    },
    conditions: {
      customCondition: {
        description: 'Choisissez l’une de vos propres conditions sur mesure.',
        placeholder: 'Choisissez vos conditions',
        title: 'Conditions propres',
      },
      description: 'Choisissez ici comment vous souhaitez céder vos droits d’auteur à votre client.',
      specialConditionsAction: 'Conditions particulières',
      title: 'Comment cédez-vous vos droits d’auteur ?',
      tooltip: 'Les conditions générales personnalisées ne sont pour l’instant disponibles qu’en néerlandais.',
      transfer: {
        description: 'Vous cédez les droits à votre client, après paiement de la facture.',
      },
      usageRight: {
        description: 'Vous accordez un droit d’utilisation à votre client, vous conservez ainsi les droits.',
      },
      viewPdf: 'Relire les conditions',
    },
    confirmation: {
      description:
        'Toutes les informations sont remplies et votre facture est complète ? Nous la vérifions minutieusement avant de l’approuver.',
      descriptionEdit:
        'Facture modifiée, prête à être renvoyée ? Dès que vous l’aurez fait, nous pourrons l’approuver. Pas encore prêt·e ? Enregistrez votre facture sans l’envoyer.',
      entryNumber: {
        close: 'Fermer la modification',
        confirm: 'Confirmer la modification',
        creditNoteNumber: 'Numéro de note de crédit',
        decrease: 'Diminuer le numéro de séquence',
        edit: 'Modifier le numéro de séquence',
        increase: 'Augmenter le numéro de séquence',
        invoiceNumber: 'Numéro de facture',
        prefix: 'Préfixe',
        reset: 'Réinitialiser le numéro de séquence',
        serialNumber: 'Numéro de séquence',
        suffix: 'Suffixe',
        warning:
          'La série de numérotation garantit que vos documents sont automatiquement numérotés correctement. Vous pouvez la modifier, mais vous en êtes alors responsable.',
      },
      minCommission: 'La commission minimale de 12,50 € s’applique à cette facture.',
      sentWithPeppol: 'Après approbation, votre facture sera envoyée via Peppol.',
      sentWithPeppolInstant: 'Votre facture sera envoyée via Peppol.',
      submit: {
        create: 'Oui, créer la facture',
        edit: 'Oui, envoyer la facture',
        saveAndExit: 'Enregistrer et quitter',
      },
      title: 'Votre facture nous est envoyée',
      titleEdit: 'Votre facture nous est renvoyée',
    },
    invoiceDetails: {
      dueDate: 'Date d’échéance',
      dueDatePlaceholder: 'Sélectionnez une date d’échéance',
      numberingSeriesPlaceholder: 'Choisissez une série de numérotation',
      title: 'Détails de la facture',
    },
    lines: {
      description: 'Listez ici les produits et/ou services que vous proposez.',
      title: 'Lignes de facture',
    },
    preview: 'Exemple',
    remark: {
      description: 'Remarques ou questions pour Creative Shelter.',
      title: 'Remarques',
    },
    saveAndExitDialog: {
      description:
        'Vos modifications seront enregistrées, mais votre facture reste en cours de modification. Tant que vous ne l’avez pas renvoyée, nous ne pouvons pas l’approuver.',
      saveAndExit: 'Enregistrer et quitter',
      send: 'Envoyer quand même',
      title: 'Enregistrer la facture sans l’envoyer ?',
    },
    submit: {
      saveAndExit: 'Enregistrer et quitter',
      saveSend: 'Enregistrer et envoyer',
    },
    title: {
      create: 'Brouillon de facture',
      edit: 'Modifier la facture',
    },
    vatExemptLimit: {
      exceeded: {
        buttonText: 'J’ai compris !',
        description:
          'Votre chiffre d’affaires total dépasse 25 000 €. Vous ne pouvez donc plus utiliser le régime standard de franchise de TVA. Pouvez-vous d’abord modifier votre régime de TVA avant de continuer à facturer ? Vous trouverez plus d’informations <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target="_blank">ici</a>.',
        title: 'Limite atteinte',
      },
      firstWarning: {
        buttonText: 'OK, compris !',
        description:
          'Votre chiffre d’affaires total approche les 25 000 €. Au-delà de ce seuil, vous ne pouvez plus utiliser le régime standard de franchise de TVA. Gardez donc un œil sur votre chiffre d’affaires.',
        title: 'Presque à la limite',
      },
      secondWarning: {
        buttonText: 'OK, j’ai compris !',
        description:
          'Votre chiffre d’affaires total approche les 25 000 €. Pour pouvoir utiliser le régime standard de franchise de TVA, vous ne pouvez pas dépasser ce seuil. Modifiez votre régime de TVA à temps.',
        title: 'Limite presque atteinte',
      },
    },
  },
  details: {
    confirmDownloadFcInvoiceModal: {
      buttonText: 'OK, compris !',
      description: 'Cette facture est uniquement destinée à votre comptabilité, ne la transmettez donc pas à votre client.',
      peppol: 'Vous avez déjà reçu cette facture dans votre boîte de réception Peppol. Vous pouvez la télécharger à nouveau ici.',
      title: 'Attention !',
    },
    confirmEditModal: {
      bodyLocked:
        'Cette facture est encore en mode modification. C’est justement pour cela que nous ne pouvons pas encore l’approuver. Vous avez terminé, tout est complété ou modifié ? N’oubliez pas de renvoyer votre facture.',
      bodyPending:
        'Cette facture est en attente d’approbation. Vous pouvez encore la modifier, mais n’oubliez pas de la renvoyer une fois que vous avez terminé.',
      confirm: 'J’ai compris',
      title: 'Attention !',
    },
    confirmResendCoInvoiceModal: {
      confirm: 'OK, envoyer',
      descriptionSendFromCreativeShelter: 'Votre client recevra à nouveau la facture, avec vous en copie.',
      descriptionSendFromFreelancer:
        'Vous avez indiqué envoyer vous-même les factures. Vous la recevrez donc vous-même pour l’envoyer ensuite par e-mail à votre client.',
      title: 'Vérification',
    },
    copyright: {
      label: 'Droits d’auteur',
      subtitle: 'Vos droits d’auteur',
      viewDocument: 'Relire le document',
    },
    error: {
      title: 'Erreur lors du chargement de votre facture.',
    },
    followUp: {
      modal: {
        accept: 'Démarrer',
        addRemark: 'Ajouter une remarque',
        input: {
          placeholder: 'Remarque éventuelle',
        },
        message:
          'Votre client a reçu des e-mails de rappel automatiques pour votre facture, mais aucun paiement n’a suivi. En démarrant un suivi, nous contactons personnellement votre client pour le paiement de votre facture.\n\nPouvons-nous démarrer ce suivi ?',
        remarkMessage:
          'Avez-vous des informations supplémentaires ou une remarque avant que nous démarrions le suivi de votre facture ? Indiquez-les ici.\n\nD’autres questions ? Envoyez un e-mail à administratie@creativeshelter.be.',
        title: 'Démarrer le suivi',
        titleRemark: 'Suivi démarré',
      },
      start: 'Démarrer le suivi de la facture impayée',
    },
    history: {
      error: {
        title: 'Erreur lors du chargement de l’historique.',
      },
      message: {
        Approved: {
          default: 'Approuvée',
          instant: 'Approuvée instantanément',
        },
        Created: {
          default: 'Créée en tant que brouillon',
        },
        CreditNoteApproved: {
          default: 'Note de crédit approuvée par Creative Shelter',
        },
        CreditNoteEmailApprovedAndSent: {
          client: 'Note de crédit envoyée à votre client',
          user: 'Note de crédit envoyée à votre adresse e-mail',
        },
        Credited: {
          default: 'Créditée',
        },
        EmailApprovedAndSent: {
          client: 'Facture envoyée à votre client',
          user: 'Facture envoyée à votre adresse e-mail',
        },
        EmailPaymentReminder: {
          first: 'Premier e-mail de rappel (automatique) envoyé à votre client',
          second: 'Deuxième e-mail de rappel (automatique) envoyé à votre client',
        },
        Expired: {
          default: 'Échue',
        },
        Finalized: {
          default: 'Envoyée pour approbation',
        },
        FollowUpContactClientByPhone: {
          default: 'Contact téléphonique par l’administration de Creative Shelter',
        },
        FollowUpFormalNoticeSent: {
          default: 'Mise en demeure rédigée et envoyée',
        },
        FollowUpInvoiceSentToBailiff: {
          default: 'Suivi par l’huissier de justice démarré',
        },
        FollowUpInvoiceSentToLawyer: {
          default: 'Mise en demeure envoyée par l’avocat',
        },
        FollowUpLastManualReminder: {
          default: 'Derniers e-mails de rappel envoyés par l’administration de Creative Shelter',
        },
        FollowUpManualReminder: {
          default: 'E-mails de rappel envoyés par l’administration de Creative Shelter',
        },
        FollowUpStarted: {
          default: 'Suivi du paiement démarré',
        },
        LockedByUser: {
          default: 'Mise en mode modification',
        },
        PaidByClient: {
          default: 'Payée par votre client',
        },
        PaidByCreativeShelter: {
          default: 'Versée par Creative Shelter',
        },
        PartiallyPaid: {
          default: 'Paiement partiel de {{amount}} reçu',
        },
        PeppolCoAccepted: {
          creditNote: 'Note de crédit acceptée via Peppol par votre client',
          default: 'Acceptée via Peppol par votre client',
        },
        PeppolCoDelivered: {
          creditNote: 'Note de crédit arrivée dans la boîte de réception Peppol de votre client',
          default: 'Arrivée dans la boîte de réception Peppol de votre client',
        },
        PeppolCoRefused: {
          creditNote: 'Note de crédit refusée via Peppol par votre client',
          default: 'Refusée via Peppol par votre client',
        },
        PeppolCoSent: {
          creditNote: 'Note de crédit envoyée via Peppol à votre client',
          default: 'Envoyée via Peppol à votre client',
        },
        PeppolFcAccepted: {
          creditNote: 'Note de crédit acceptée via Peppol par vous',
          default: 'Acceptée via Peppol par vous',
        },
        PeppolFcDelivered: {
          creditNote: 'Note de crédit arrivée dans votre boîte de réception Peppol',
          default: 'Arrivée dans votre boîte de réception Peppol',
        },
        PeppolFcRefused: {
          creditNote: 'Note de crédit refusée via Peppol par vous',
          default: 'Refusée via Peppol par vous',
        },
        PeppolFcSent: {
          creditNote: 'Note de crédit envoyée via Peppol à vous',
          default: 'Envoyée via Peppol à vous',
        },
      },
    },
    paymentInfo: {
      alreadyPaid: 'Déjà payé',
      dueDate: 'Date d’échéance',
      expectedPaidDate: 'Date de paiement prévue',
      expectedPaidDateTooltip:
        'Vous recevez le paiement de Creative Shelter le premier jour ouvrable après que nous avons reçu le paiement de votre client.',
      paidDate: 'Date de paiement',
      partialPayment: 'Paiement {{number}}',
      remaining: 'Reste à payer',
      status: {
        options: {
          credited: 'Créditée',
          fcPaid: 'Versée',
          notPaid: 'En attente de paiement',
          paid: 'Payée',
        },
      },
      transportType: {
        label: 'Mode d’envoi',
        options: {
          Email: 'E-mail',
          Peppol: 'Peppol',
        },
      },
      vatExceptionallyExempt: 'Exonéré',
      withholdingTax: 'Précompte mobilier',
    },
    paymentInfoDetail: {
      remark: {
        byAdmin: 'Remarque de {{name}}.',
        byUser: 'Votre remarque',
      },
      types: {
        FollowUpContactClientByPhone: {
          description:
            'Nous appelons votre client pour obtenir des nouvelles de votre facture impayée. Du nouveau ? Nous vous tiendrons au courant.',
        },
        FollowUpFormalNoticeSent: {
          description:
            'Une mise en demeure a été envoyée à votre client. Elle est envoyée par e-mail et par courrier postal, pour être sûrs qu’elle lui parvienne.',
        },
        FollowUpInvoiceSentToBailiff: {
          description: 'Un huissier de justice a été désigné. Il reprend le dossier et le contact avec votre client.',
        },
        FollowUpInvoiceSentToLawyer: {
          description:
            'Une mise en demeure a été envoyée par l’intermédiaire d’un avocat partenaire. Elle est envoyée par e-mail et par courrier postal, pour être sûrs qu’elle parvienne à votre client.',
        },
        FollowUpLastManualReminder: {
          description:
            'Votre client a déjà reçu plusieurs rappels (par e-mail et par téléphone), mais aucun paiement n’a encore suivi.\n<br>\nUn tout dernier rappel manuel va suivre. Pas de réaction ni de nouvelles concernant le paiement ? Nous pourrons alors entreprendre des démarches supplémentaires.',
        },
        FollowUpManualReminder: {
          description: 'Un premier rappel manuel a été envoyé à votre client. Dès qu’il y a du nouveau, nous vous tenons au courant.',
        },
        FollowUpStarted: {
          description:
            'Nous assurons le suivi de votre facture impayée. Nous commençons par des rappels supplémentaires et un contact téléphonique.\n<br>\nCela ne suffit pas ? D’autres démarches suivent alors : une mise en demeure, une deuxième via notre avocat partenaire et éventuellement l’huissier de justice (en Belgique).\n<br>\nDès qu’il y a du nouveau, nous vous faisons signe.',
        },
      },
    },
    split: {
      amount: 'Montant',
      amountExclVat: 'Montant (hors TVA)',
      co: {
        description: 'Votre client reçoit cette facture et paie Creative Shelter.',
        eyebrow: 'Facture pour votre client',
        highlight: 'Votre client paie',
        preview: 'Voir la facture',
      },
      copyrightGroup: 'Droits d’auteur',
      copyrightTotal: 'Total des droits d’auteur (net)',
      description: 'Dès que votre facture est approuvée, nous créons automatiquement 2 factures. Voici pourquoi :',
      fc: {
        description:
          'Dès que votre client a payé, nous vous versons séparément les revenus professionnels et la rémunération en droits d’auteur.',
        download: 'Télécharger votre facture',
        eyebrow: 'Facture pour vous',
        highlight: 'Vous recevez',
      },
      performanceGroup: 'Revenus professionnels',
      title: 'Pourquoi 2 factures ?',
      totalInclVat: 'Total (TVA comprise)',
    },
    statusInfo: {
      message: {
        Approved: {
          default: 'Votre facture a été approuvée et envoyée à votre client.',
        },
        CoPaid: {
          default: 'Votre client a payé la facture. Vous recevrez le paiement de Creative Shelter le jour ouvrable suivant.',
        },
        Credited: {
          default: 'Vous avez crédité cette facture.<br>Numéro de note de crédit : {{creditNoteNumber}}.<br>Motif : {{creditNoteReason}}',
        },
        Expired: {
          coPartiallyPaid: 'Nous avons reçu un paiement partiel de votre client. Vous pouvez suivre les paiements en détail ci-dessous.',
          default:
            'Votre facture est échue. Nous assurons le suivi pour vous auprès de votre client selon <a href="https://knowledge.creativeshelter.be/wat-als-mijn-klant-opdrachtgever-nog-niet-betaald-heeft-op-de-vervaldag" target="_blank">nos directives</a>.',
          followingUp:
            'Votre facture n’a pas été payée par votre client dans le délai d’échéance. Pour obtenir le paiement, nous avons démarré le suivi nécessaire. Vous pouvez suivre chaque étape ci-dessous.',
        },
        FcPaid: {
          default: 'Votre facture a été versée. Vous trouverez le détail des paiements ci-dessous.',
        },
        InReview: {
          default:
            'Nous avons reçu votre facture et l’approuverons dans les plus brefs délais. Vous voulez facturer encore plus vite ? <a href="https://knowledge.creativeshelter.be/producten-wat-zijn-ze-en-hoe-gebruik-je-ze" target="_blank">Découvrez ici</a> comment utiliser les produits pour facturer instantanément.',
        },
        LockedByUser: {
          default:
            'Votre facture est en cours de modification. Cela signifie que nous ne pouvons pas la vérifier, l’approuver ni l’envoyer à votre client. Pouvez-vous la renvoyer une fois qu’elle est complétée ou modifiée ?',
        },
      },
      title: {
        inReview: 'Envoyée pour approbation',
        paymentFollowUp: 'Paiement en cours de suivi',
        sentWithPeppol: 'Envoyée via Peppol',
      },
    },
    summary: {
      client: {
        noClient: 'Aucun client sélectionné.',
      },
      content: {
        noDescription: 'Aucune description saisie.',
      },
      copyright: {
        conditionsChecklist: {
          onlineCourse: {
            item1: 'Vous autorisez Creative Shelter à mettre votre cours à la disposition de votre client.',
            item2: 'Votre client peut consulter, conserver ou imprimer votre cours pour son usage personnel.',
            item3: 'Toute autre diffusion ou publication n’est pas autorisée.',
          },
          rightOfUse: {
            item1: 'Vous restez propriétaire de votre œuvre.',
            item2: 'Votre client obtient le droit d’utiliser votre œuvre comme prévu (p. ex. la montrer ou la diffuser).',
            item3: 'Ce droit est illimité dans le temps, l’espace et la forme (sauf accord contraire).',
          },
          transfer: {
            item1: 'Vous cédez les droits sur votre œuvre à votre client.',
            item2: 'Votre œuvre peut être utilisée, modifiée et diffusée dans le monde entier et sans limitation.',
            item3: 'Vous restez l’auteur, mais vous n’en êtes plus le propriétaire juridique (sauf accord contraire).',
          },
        },
        noConditions: 'Aucune condition sélectionnée.',
        notAvailable: 'Non disponible',
        type: {
          condition: 'Conditions générales',
          customCondition: 'Conditions générales personnalisées',
        },
        viewPdf: 'Voir le PDF',
      },
      lines: {
        noLines: 'Aucune ligne de facture ajoutée.',
      },
    },
    timeline: {
      title: 'Chronologie',
    },
  },
  fields: {
    billingPeriod: {
      helpText: 'Date d’échéance <0>{{ date }}</0>',
      label: 'Délai de paiement',
      options: {
        '15': '15 jours',
        '30': '30 jours',
        '45': '45 jours',
        '60': '60 jours',
      },
    },
    billingPeriodEndOfMonth: {
      label: 'Fin de mois',
      tooltip: 'Calculer le délai de paiement à partir de la fin du mois.',
    },
    brandId: {
      label: 'Nom commercial',
      placeholder: 'Sélectionnez un nom commercial',
    },
    clientId: {
      add: 'Ajouter un client',
      label: 'Client',
      placeholder: 'Sélectionnez un client',
    },
    condition: {
      label: 'Comment cédez-vous vos droits d’auteur ?',
      link: 'Relire les conditions',
      placeholder: 'Sélectionnez un régime',
    },
    contactId: {
      add: 'Ajouter une personne de contact',
      placeholder: 'Sélectionnez une personne de contact',
    },
    customAgreementId: {
      description_one:
        'Vous avez déjà un contrat en cours avec {{name}}. Vous n’avez rien à faire, nous faisons automatiquement référence à votre contrat.',
      description_other:
        'Vous avez plusieurs contrats en cours avec {{name}}. Choisissez ici dans le cadre de quel contrat s’inscrit ce document.',
      label: 'Contrat-cadre',
      placeholder: 'Sélectionnez un contrat-cadre',
    },
    description: {
      label: 'Description',
      placeholder: 'Décrivez brièvement en quoi consiste votre mission',
    },
    entryNumber: {
      label: 'Numéro de facture',
    },
    numberingSeriesId: {
      helpText: 'Le numéro de facture sera <0>{{entryNumber}}</0>.',
      label: 'Série de numérotation',
      labelTooltip:
        'Des questions sur la création d’une série de numérotation ? Cliquez <a href="https://knowledge.creativeshelter.be/wat-is-een-nummeringreeks-en-hoe-stel-ik-deze-in" target="_blank">ici</a> pour plus d’informations.',
      none: 'Aucune série de numérotation',
      placeholder: 'Sélectionnez une série de numérotation',
      tooltip:
        'Ceci est un aperçu de votre numéro de facture. Le numéro ne devient définitif qu’au moment où vous nous envoyez la facture.',
      tooltipCreate:
        'Une série de numérotation vous aide à numéroter vos factures correctement et facilement. Vous pouvez en créer autant que vous le souhaitez, mais une seule suffit. Vous voulez en savoir plus ou vous avez encore des questions ? <a href="https://knowledge.creativeshelter.be/wat-is-een-nummeringreeks-en-hoe-stel-ik-deze-in" target="_blank">C’est par ici.</a>',
    },
    orderReference: {
      label: 'Numéro de bon de commande (PO) du client',
      placeholder: 'Numéro de bon de commande (PO) du client',
    },
    remark: {
      label: 'Remarques',
      placeholder: 'Une remarque ou une question supplémentaire sur votre facture, à l’attention de Creative Shelter ? Indiquez-la ici !',
    },
    specialConditions: {
      custom: 'Ce document s’inscrit dans le cadre de notre contrat du {{date}}',
      label: 'Conditions particulières',
      placeholder: 'Indiquez ici les éventuelles conditions particulières.',
    },
    title: {
      label: 'Titre',
      placeholder: 'Titre',
    },
  },
  header: {
    actionBlock: {
      button: 'Créer une facture',
      dropdown: {
        creditnote: 'Créer une note de crédit',
        invoiceTemplate: 'Créer un modèle de facture',
        notCreative: 'Facture non créative (Billit)',
      },
    },
    title: 'Factures',
  },
  overview: {
    columns: {
      client: 'Client',
      date: 'Date de facture',
      days: 'jours',
      dueDate: 'Date d’échéance',
      entryNumber: 'Facture',
      saved: 'Avantage',
      status: {
        lockedByUserTooltip:
          'Oups ! Cette facture est en « mode modification », nous ne pouvons donc pas l’approuver. Cliquez sur « Modifier la facture » pour envoyer votre facture.',
        options: {
          Approved: 'Envoyée',
          CoPaid: 'Payée',
          Credited: 'Créditée',
          Draft: 'Brouillon',
          Expired: 'Échue',
          FcPaid: 'Versée',
          InReview: 'En attente d’approbation',
          LockedByUser: 'En cours de modification',
        },
        sentWithPeppolTooltip: 'via Peppol',
        title: 'Statut',
      },
      substatus: {
        CoPartiallyPaid: 'Partiellement payée',
        PaymentInFollowUp: 'Paiement en cours de suivi',
      },
      total: 'Total (hors TVA)',
    },
    created: {
      subtitle: 'Factures',
    },
    createdFromTemplateTooltip: 'Cette facture a été créée à partir d’un modèle.',
    emptyState: {
      completeAccount: 'Compléter le compte',
      createInvoice: 'Créer une facture',
      text: 'Créez une nouvelle facture rapidement et facilement. En quelques étapes, elle est prête à être envoyée.',
      title: 'Prêt·e à créer votre première facture ?',
    },
    error: {
      title: 'Erreur lors du chargement de vos factures.',
    },
    lockedByAdmin: {
      description: 'La facture numéro {{number}} ne peut plus être modifiée, car nous sommes déjà en train de l’approuver.',
      title: 'La facture ne peut pas être modifiée.',
    },
    rowActions: {
      advantage: 'Voir l’avantage',
      credit: 'Créditer',
      details: 'Plus de détails',
      download: 'Télécharger',
      duplicate: 'Copier',
      edit: {
        error: 'Une erreur s’est produite lors de l’ouverture de la facture. Veuillez réessayer plus tard.',
        label: 'Modifier',
      },
      preview: 'Voir la facture client',
      resendCoInvoice: 'Renvoyer',
    },
  },
};
